import React, { useEffect } from 'react';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  HasLoadedFromCookieSelector,
  InitialDataSelector,
  ShowResetButtonsSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import {
  setFitStatus,
  setHasFinishedSelection,
  setShowFitAssistant,
  setShowResetButtons,
  setStepEnum,
} from '../../Slices/FitAssistantSlice';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import { trackNoFit, trackView } from '../../Analytics/Adobe.ts';
import Buttons from '../Buttons/Buttons.tsx';
import FitAssistantStatus from '../../Enums/FitAssistantStatus.ts';
import FitAssistantStep from '../../Enums/FitAssistantStep.ts';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import { CloseType } from '../../Types/Tracking.ts';

const NoFitPlatforms = () => {
  const dispatch = useAppDispatch();
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStep = useAppSelector(CurrentStepSelector);
  const currentStepContent = useAppSelector(CurrentStepContentSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const translations = useAppSelector(TranslationsSelector);
  const showResetButtons = useAppSelector(ShowResetButtonsSelector);
  const hasLoadedFromCookie = useAppSelector(HasLoadedFromCookieSelector);

  useEffect(() => {
    trackView(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      hasLoadedFromCookie
    );

    dispatch(setHasFinishedSelection(true));
  }, []);

  const trackNoFitClick = (closeType: CloseType, clickLink?: string) => {
    trackNoFit(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      closeType,
      clickLink
    );
  };

  const onClickPrimary = () => {
    trackNoFitClick('Close');
    dispatch(setShowFitAssistant(false));
    dispatch(setShowResetButtons(true));
  };

  const onclickSecondary = () => {
    trackNoFitClick('Reset');
    dispatch(resetFitAssistant(false));
  };

  const onExistingRackClick = () => {
    dispatch(setFitStatus(FitAssistantStatus.NoSelection));
    dispatch(setStepEnum(FitAssistantStep.RackMounting));
  };

  return (
    <>
      <div>
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: currentStepContent?.Text ?? '',
          }}
        />
        {currentStepContent?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100">
            <img src={currentStepContent?.ImageUrl} alt={currentStepContent?.ImageAlt} />
          </div>
        )}
        <div className="rack-selector d-flex flex-column justify-content-center">
          <div className="rack-options mt-6" onClick={onExistingRackClick}>
            <div className="rack-option d-flex mb-4 px-1 py-1">
              <div className="image-wrapper d-flex justify-content-center w-100"></div>
              <div className="info d-flex flex-column justify-content-center">
                <h5 className="mb-1">{translations.mountOnExistingRack}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Buttons visible>
        <PrimaryButton visible text={translations.close} onClick={onClickPrimary} />
        <SecondaryButton visible={showResetButtons} text={translations.reset} onClick={onclickSecondary} />
      </Buttons>
    </>
  );
};

export default NoFitPlatforms;
